/**
 * CompanyDocs — página completa de documentación de la empresa.
 * Ruta: /documentation-empresa (entrada de menú justo debajo de Dashboard).
 *
 * Reutiliza el mismo bloque que el Dashboard (DashboardDocs) en variante
 * "full": lista todos los documentos sin recortar, con buscador siempre
 * visible, sus elementos vinculados y la creación de notas de empresa.
 */
import React from 'react';
import DashboardDocs from '../components/DashboardDocs';

export default function CompanyDocs({ companyId }) {
  if (!companyId) {
    return (
      <div className="container-fluid py-3">
        <div className="dbd">
          <div className="dbd-empty">
            <span className="dbd-empty-icon">🏢</span>
            <p className="dbd-empty-title">Selecciona una empresa</p>
            <p className="dbd-empty-copy">
              Usa el selector de la barra superior para ver la documentación de cada empresa.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid py-3">
      <DashboardDocs companyId={companyId} variant="full" />
    </div>
  );
}
